export function getView(connection_resource_status, is_admin) {
  return (
    is_admin &&
    ['created', 'setup_automations', 'disabled', undefined].includes(
      connection_resource_status
    )
  )
}
